import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnDestroy, OnInit, forwardRef } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

import { TranslateService } from '@codeandweb/ngx-translate';

import { Observable, Subscription } from 'rxjs';

import { DropdownModule } from '@app/primeng-overrides/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';

import { AbonneService } from '@app/abonne/abonne.service';
import { Famille, Nomenclature } from '@app/nomenclature/nomenclature.model';
import { NomenclatureService } from '@app/nomenclature/nomenclature.service';
import { UtilisateurService } from '@app/utilisateur/utilisateur.service';

import { ControlValueAccessorBase } from '@app/_helpers/control-value-accessor-base';
import { stringSort } from '@helpers/utils';

@Component({
	selector: 'famille-selector',
	 providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => FamilleSelectorComponent),
			multi: true
		}
	],
	template: `
		<p-dropdown
			[name]="name"
			[required]="required"
			[options]="options"
			[(ngModel)]="value"
			[filter]="options.length > 5"
			filterBy="fam_nom"
			[readonly]="readonly"
			[ngClass]="{'p-readonly': readonly}"
			[placeholder]="_placeholder"
			[disabled]="disabled"
			[showClear]="nullOption"
			optionValue="fam_id"
			optionLabel="fam_nom"
			appendTo="body"
		>
		</p-dropdown>
	`
})
export class FamilleSelectorComponent extends ControlValueAccessorBase<number> implements OnInit, OnDestroy  {

	@Input() name: string;
	@Input('value') innerValue: number;
	@Input() required: boolean;
	@Input() readonly: boolean;
	@Input() placeholder: string;
	@Input() nullIfInvalid: boolean;
	@Input() nullOption: boolean;
	@Input() disabled: boolean;
	@Input() unavailableFamilles?: number[];

	_placeholder: string = 'Sélectionnez';

	options: {fam_id: number, fam_nom: string}[] = [];

	subscriptionLangChange?: Subscription;

	constructor(
		private nomenclatureService: NomenclatureService,
		private translateService: TranslateService,
		private abonneService: AbonneService,
		private utilisateurService: UtilisateurService,
	) {
		super();

		if (this.placeholder == undefined) {
			this.subscriptionLangChange = this.translateService.onLangChange.subscribe(() => {
				this._placeholder = translateService.instant('common.selector_placeholder');
			});
		}
	}

	ngOnInit() {
		if (this.placeholder != undefined) {
			this._placeholder = this.placeholder;
		}

		let currentAbonne = this.abonneService.currentAbonneValue;
		let currentUtilisateur = this.utilisateurService.currentUtilisateurValue;

		this.nomenclatureService.getCacheNomenclatureAccessibleParUtilisateur(currentUtilisateur, currentAbonne?.abo_id)
		.subscribe(({ familles }) => {
			let tmp = familles.filter((famille: Famille) => famille.fam_actif);
			stringSort(tmp, 'fam_nom');

			if (this.unavailableFamilles != undefined) {
				tmp = tmp.filter((famille: Famille) => !this.unavailableFamilles?.includes(famille.fam_id))
			}

			this.options = [...tmp];
		});
	}

	ngOnDestroy(): void {
		this.subscriptionLangChange?.unsubscribe();
	}
}


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		AutoCompleteModule,
		DropdownModule
	],
	exports: [FamilleSelectorComponent],
	declarations: [FamilleSelectorComponent]
})
export class FamilleSelectorModule { }
